import { toast } from "react-toastify";
import { useState } from "react";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import CloseIcon from "@mui/icons-material/Close";
import { colors } from "../styles";
import Button from "./Button";
import { SectionFlexColumn, SectionFlexRow } from "./General";
import { ReactComponent as LightningIcon } from "../assets/icons/lightning.svg";
import { IconButton } from "@mui/material";
import api from "../api/api";
import { CONTACT_SALES } from "../api/queryKeys";

const ModalContainer = styled("div")(`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 500px;
  background-color: ${colors.white};
  border-radius: 5px;
  padding: 16px 32px;
`);

const H2 = styled("h2")(`
  font-size: 20px;
  margin: 0;
  margin-left: 8px;
`);

const F3 = styled("p")(`
  font-size: 14px;
`);

const Input = styled(OutlinedInput)({
  width: "100%",
  minHeight: 90,
});

interface Props {
  modalStatus: boolean;
  closeModal: () => void;
  customDescription?: string;
}

const TalkWithSalesModal = ({
  modalStatus,
  closeModal,
  customDescription,
}: Props) => {
  const [message, setMessage] = useState("");

  const handleClick = async () => {
    try {
      const response = await api.post(CONTACT_SALES, { message });
      if (response.data.success) {
        toast.success("Message sent successfully. We'll be in touch soon.");
        setMessage("");
        closeModal();
      } else {
        toast.error("Unable to send message.");
      }
    } catch (error) {}
  };

  return (
    <Modal
      open={modalStatus}
      onClose={closeModal}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <ModalContainer>
        <SectionFlexColumn style={{ display: "flex", alignItems: "start" }}>
          <SectionFlexRow style={{ marginTop: 20 }}>
            <LightningIcon />
            <H2>Contact Sales</H2>
            <IconButton onClick={closeModal} style={{ marginLeft: "auto" }}>
              <CloseIcon />
            </IconButton>
          </SectionFlexRow>
          <F3>
            {customDescription
              ? customDescription
              : "Our team will reach out shortly via email."}
          </F3>
        </SectionFlexColumn>
        <Input
          placeholder="Your message (optional)"
          multiline
          value={message}
          onChange={(e) => setMessage((e.target as HTMLInputElement).value)}
        />
        <Button onClick={handleClick}>Get in Touch</Button>
      </ModalContainer>
    </Modal>
  );
};

export default TalkWithSalesModal;
